// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.customParentTableClass{


    display: flex;
    width: 100%;
    
}

.customParentTableClass thead {
    position: sticky;
    top: 0;

    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
    /* border-radius: 4px; */
    overflow: hidden;
}
.setting{
    z-index: 1;
}


.TableClass::-webkit-scrollbar {
    width: 6px;
}
  
  /* Track */
.TableClass::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgb(214, 214, 214); 
    border-radius: 10px;
    /* margin-top: 35px; */
    /* margin-bottom: 5px; */
}
   
  /* Handle */
.TableClass::-webkit-scrollbar-thumb {
    background: rgb(0, 0, 0); 
    border-radius: 10px;
}
  
  /* Handle on hover */
.TableClass::-webkit-scrollbar-thumb:hover {
    background: #4c4c4c; 
}
  `, "",{"version":3,"sources":["webpack://./src/component/TableDisplay/TableDispla.css"],"names":[],"mappings":";;AAEA;;;IAGI,aAAa;IACb,WAAW;;AAEf;;AAEA;IACI,gBAAgB;IAChB,MAAM;;IAEN,6CAA6C;IAC7C,wBAAwB;IACxB,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;;;AAGA;IACI,UAAU;AACd;;EAEE,UAAU;AACZ;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;AAC5B;;EAEE,WAAW;AACb;IACI,wBAAwB;IACxB,mBAAmB;AACvB;;EAEE,oBAAoB;AACtB;IACI,mBAAmB;AACvB","sourcesContent":["\n\n.customParentTableClass{\n\n\n    display: flex;\n    width: 100%;\n    \n}\n\n.customParentTableClass thead {\n    position: sticky;\n    top: 0;\n\n    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);\n    /* border-radius: 4px; */\n    overflow: hidden;\n}\n.setting{\n    z-index: 1;\n}\n\n\n.TableClass::-webkit-scrollbar {\n    width: 6px;\n}\n  \n  /* Track */\n.TableClass::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px rgb(214, 214, 214); \n    border-radius: 10px;\n    /* margin-top: 35px; */\n    /* margin-bottom: 5px; */\n}\n   \n  /* Handle */\n.TableClass::-webkit-scrollbar-thumb {\n    background: rgb(0, 0, 0); \n    border-radius: 10px;\n}\n  \n  /* Handle on hover */\n.TableClass::-webkit-scrollbar-thumb:hover {\n    background: #4c4c4c; \n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
